export default "__VITE_ASSET__Bzxo4IdD__"